export enum APP_RUNTIME {
	WEB_VIEW = 'webview',
	WEB = 'web',
	REACT_NATIVE = 'react-native'
}
